module.exports = __webpack_public_path__ + "static/media/home-loan.94cf05c2.jpg";